<template>
  <div>
    <el-dialog :visible.sync="imageshow" width="800px" center>
      <el-table :data="imgData" stripe :default-sort="{prop: 'row', order: 'order'}">
        <el-table-column prop="row" label="层数" align="center"></el-table-column>
        <el-table-column prop="image" label="图片" align="center">
          <template slot-scope="scope">
            <img
              :src="scope.row.image"
              width="40px"
              height="40px"
              @click="showImg(scope.row)"
              style="cursor:pointer"
            />
          </template>
        </el-table-column>
        <el-table-column prop="purity" label="纯净度" align="center">
          <template slot-scope="scope">
            <div class="green" v-if="scope.row.purity>=90">{{scope.row.purity}}%</div>
            <div
              class="yellow"
              v-else-if="scope.row.purity>=51 && scope.row.purity<90"
            >{{scope.row.purity}}%</div>
            <div class="red" v-else>{{scope.row.purity}}%</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="simpleImg">
        <div class="simpleOne green" v-if="all_purity>=90">总纯净度:{{all_purity}}%</div>
        <div
          class="simpleOne yellow"
          v-else-if="all_purity>=51 && all_purity<90"
        >总纯净度:{{all_purity}}%</div>
        <div class="simple red" v-else>总纯净度:{{all_purity}}%</div>
        <div class="simpleTwo">*纯净度值仅供参考</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imageshow = false">取 消</el-button>
        <el-button type="primary" @click="imageshow = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible" width="850px" top="5%">
      <div v-if="this.enlargeImg">
        <img :src="this.enlargeImg" width="800px" height="600px" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/config/apis";
export default {
  data() {
    return {
      imgData: [],
      imgDialogVisible: false,
      all_purity: "",
      imageshow: false,
      enlargeImg: "",
      id: "",
      imgparams: ""
    };
  },
  props: {},
  mounted() {},
  methods: {
    show(row) {
      this.id = row.id;
      this.imgparams = "true";
      this.getData();
    },
    showDetail(row) {
      this.id = row.id;
      this.getDataDetails();
    },
    showImg(row) {
      this.enlargeImg = row.image;
      this.imgDialogVisible = true;
    },
    getData() {
      let params = {
        flag: "true"
      };
      this.$axios.get(apis.rowdetail + this.id, { params }).then(res => {
        if (res.data.code == 200) {
          this.imageshow = true;
          this.imgData = res.data.data.list;
          this.all_purity = res.data.data.avg_purity;
        }
      });
    },
    //获取库存明细表
    getDataDetails() {
      this.$axios.get(apis.rowdetail + this.id).then(res => {
        if (res.data.code == 200) {
          this.imageshow = true;
          this.imgData = res.data.data.list;
          this.all_purity = res.data.data.avg_purity;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.simpleImg {
  display: flex;
  justify-content: space-between;
  .simpleOne {
    margin-top: 10px;
  }
  .simpleTwo {
    margin-top: 10px;
  }
}
.green {
  color: #77bc1e;
}
.yellow {
  color: orange;
}
.red {
  color: #ff0000;
}
</style>